import { render } from "./AppFooter.vue?vue&type=template&id=24b54d14&scoped=true"
import script from "./AppFooter.vue?vue&type=script&lang=js"
export * from "./AppFooter.vue?vue&type=script&lang=js"

import "./AppFooter.vue?vue&type=style&index=0&id=24b54d14&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\E-TICKET\\eticket\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24b54d14"]])

export default __exports__